import { createFileRoute, Navigate } from "@tanstack/react-router";

import { parseWorldsFilters } from "../../../workspaces/worlds/search";

export const Route = createFileRoute("/_console/p/$org/$project/simulate/create")({
  validateSearch: parseWorldsFilters,
  component: MovedCreateRoute,
});

function MovedCreateRoute() {
  return (
    <Navigate
      to="/p/$org/$project/build-worlds/create"
      params={Route.useParams()}
      search={Route.useSearch()}
      replace
    />
  );
}
